import {
  IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable,
  IQuoteBehaviorSpecifiable, instanceOfIQuoteBehaviorSpecifiable,
  IMultiLineBehaviorSpecifiable, instanceOfIMultiLineBehaviorSpecifiable,
  ITooltipBehaviorSpecifiable, instanceOfITooltipBehaviorSpecifiable,
  INaturalTextBehaviorSpecifiable, instanceOfINaturalTextBehaviorSpecifiable,
  IGroupAlertBehaviorSpecifiable, instanceOfIGroupAlertBehaviorSpecifiable,
  IEmptyAlertBehaviorSpecifiable, instanceOfIEmptyAlertBehaviorSpecifiable,
  ILengthAlertBehaviorSpecifiable, instanceOfILengthAlertBehaviorSpecifiable,
  ITextSearchBehaviorSpecifiable, instanceOfITextSearchBehaviorSpecifiable,
  IFreeInputBehaviorSpecifiable, instanceOfIFreeInputBehaviorSpecifiable,
  IInputRuleBehaviorSpecifiable, instanceOfIInputRuleBehaviorSpecifiable,
  ITranscribeBehaviorSpecifiable, instanceOfITranscribeBehaviorSpecifiable,
  IEmptyAlertAllowBehaviorSpecifiable, instanceOfIEmptyAlertAllowBehaviorSpecifiable,
  IGroupAlertAllowBehaviorSpecifiable, instanceOfIGroupAlertAllowBehaviorSpecifiable,
  IScriptExecuteTriggerBehaviorSpecifiable, instanceOfIScriptExecuteTriggerBehaviorSpecifiable,
  IInputMethodBehaviorSpecifiable, instanceOfIInputMethodBehaviorSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { ITextDrawableObject, instanceOfITextDrawableObject } from "./ITextDrawableObject";
import { ElementTypes } from "./ElementTypes";

export interface IStandardTextDrawableObject extends
ITextDrawableObject,
IPrintBehaviorSpecifiable,
IQuoteBehaviorSpecifiable,
IMultiLineBehaviorSpecifiable,
ITooltipBehaviorSpecifiable,
INaturalTextBehaviorSpecifiable,
IGroupAlertBehaviorSpecifiable,
IEmptyAlertBehaviorSpecifiable,
ILengthAlertBehaviorSpecifiable,
ITextSearchBehaviorSpecifiable,
IFreeInputBehaviorSpecifiable,
IInputRuleBehaviorSpecifiable,
ITranscribeBehaviorSpecifiable,
IEmptyAlertAllowBehaviorSpecifiable,
IGroupAlertAllowBehaviorSpecifiable,
IInputMethodBehaviorSpecifiable,
IScriptExecuteTriggerBehaviorSpecifiable {
}

export function instanceOfIStandardTextDrawableObject<T extends IStandardTextDrawableObject>(instance: any, type: ElementTypes): instance is IStandardTextDrawableObject {
  return instance
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIQuoteBehaviorSpecifiable(instance)
      && instanceOfIMultiLineBehaviorSpecifiable(instance)
      && instanceOfITooltipBehaviorSpecifiable(instance)
      && instanceOfINaturalTextBehaviorSpecifiable(instance)
      && instanceOfIGroupAlertBehaviorSpecifiable(instance)
      && instanceOfIEmptyAlertBehaviorSpecifiable(instance)
      && instanceOfILengthAlertBehaviorSpecifiable(instance)
      && instanceOfITextSearchBehaviorSpecifiable(instance)
      && instanceOfIFreeInputBehaviorSpecifiable(instance)
      && instanceOfIInputRuleBehaviorSpecifiable(instance)
      && instanceOfITranscribeBehaviorSpecifiable(instance)
      && instanceOfIEmptyAlertAllowBehaviorSpecifiable(instance)
      && instanceOfIGroupAlertAllowBehaviorSpecifiable(instance)
      && instanceOfIScriptExecuteTriggerBehaviorSpecifiable(instance)
      && instanceOfIInputMethodBehaviorSpecifiable(instance)
      && instanceOfITextDrawableObject<T>(instance, type);
}
